module.exports = __webpack_public_path__ + "img/admin_icon.d8d8f4c4.svg";